class CaseCheckModalController {
  /* @ngInject */
  constructor(
    $uibModalInstance, $http, $state,
    caseId, subCaseData
  ) {
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$state = $state;
    this.caseId = caseId;
    this.subCaseData = subCaseData;
    this.templates = [];
    this.partners = [];
  }

  $onInit() {
    this.data = {
      caseId: this.caseId,
      subCaseData: this.subCaseData,
      template: { id: '', name: '' },
      partner: { id: '', name: '' },
    };

    this.$http.get('/subCase/template')
      .then(({ data }) => {
        this.templates = data;
      });

    this.$http.get('/client/partner')
      .then(({ data }) => {
        this.partners = data;
      });
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    this.submitting = true;

    if (this.subCaseData.customSubCase) {
      this.data.subCaseData.emailBody = `<table><tr><td class="normalText" style="padding: 10px;">${
        this.data.subCaseData.emailBody}</td></tr></table>`;
    }

    this.$http.post('/subCase', this.data)
      .then(() => {
        this.submitting = false;
        this.reload();
      }).catch(() => (this.submitting = false));
  }

  reload() {
    this.submitting = false;
    this.$uibModalInstance.close();
    if (this.subCaseData.customSubCase) {
      this.$state.reload();
    } else {
      this.$state.go('main.cases.view', { id: this.caseId });
    }
  }
}

export default CaseCheckModalController;



// WEBPACK FOOTER //
// ./client/components/allocate-subcase-modal/allocate-subcase-modal.js